import { PV_DISCLOSURE_SECURITY_CATALOG } from "@/types/PresenterModel/PV_DISCLOSURE_SECURITY_CATALOG";
import { API_RES_SECURITY_NAME_LIST_ITEM } from "../../types/apiModel/Disclosure/API_RES_SECURITY_NAME";

export function isSecurityCatalogListItem(
  v: API_RES_SECURITY_NAME_LIST_ITEM
): v is PV_DISCLOSURE_SECURITY_CATALOG {
  return !!(v.securityCode && v.securityKorName);
}
